<div class="d-flex">
  <div class="ms-3 hstack mb-4 gap-3">
    <app-data-box [label]="'DEA-ID'" [data]="guestCard?.dea_id"></app-data-box>
    <app-data-box [label]="'Cognome'" [data]="guestCard?.cognome"></app-data-box>
    <app-data-box [label]="'Nome'" [data]="guestCard?.nome"></app-data-box>
  </div>
</div>